/* tslint:disable */
/* eslint-disable */
/**
 * Y-Sports backend-next Management API
 * Composed management-facing contract for `backend-next`. This spec is an aggregation layer over module-scoped contracts and should reference canonical module definitions instead of copying them. 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface LegacyTournamentGroupSlot
 */
export interface LegacyTournamentGroupSlot {
    /**
     * 
     * @type {string}
     * @memberof LegacyTournamentGroupSlot
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof LegacyTournamentGroupSlot
     */
    groupId?: string;
    /**
     * 
     * @type {number}
     * @memberof LegacyTournamentGroupSlot
     */
    slotIndex?: number;
    /**
     * 
     * @type {string}
     * @memberof LegacyTournamentGroupSlot
     */
    teamId?: string;
    /**
     * 
     * @type {string}
     * @memberof LegacyTournamentGroupSlot
     */
    advancementRuleId?: string;
    /**
     * 
     * @type {number}
     * @memberof LegacyTournamentGroupSlot
     */
    seed?: number;
}

/**
 * Check if a given object implements the LegacyTournamentGroupSlot interface.
 */
export function instanceOfLegacyTournamentGroupSlot(value: object): value is LegacyTournamentGroupSlot {
    return true;
}

export function LegacyTournamentGroupSlotFromJSON(json: any): LegacyTournamentGroupSlot {
    return LegacyTournamentGroupSlotFromJSONTyped(json, false);
}

export function LegacyTournamentGroupSlotFromJSONTyped(json: any, ignoreDiscriminator: boolean): LegacyTournamentGroupSlot {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'groupId': json['groupId'] == null ? undefined : json['groupId'],
        'slotIndex': json['slotIndex'] == null ? undefined : json['slotIndex'],
        'teamId': json['teamId'] == null ? undefined : json['teamId'],
        'advancementRuleId': json['advancementRuleId'] == null ? undefined : json['advancementRuleId'],
        'seed': json['seed'] == null ? undefined : json['seed'],
    };
}

export function LegacyTournamentGroupSlotToJSON(json: any): LegacyTournamentGroupSlot {
    return LegacyTournamentGroupSlotToJSONTyped(json, false);
}

export function LegacyTournamentGroupSlotToJSONTyped(value?: LegacyTournamentGroupSlot | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'groupId': value['groupId'],
        'slotIndex': value['slotIndex'],
        'teamId': value['teamId'],
        'advancementRuleId': value['advancementRuleId'],
        'seed': value['seed'],
    };
}

